import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Tag';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.97949 6.98096C6.24884 7.71161 6.24884 8.89622 6.97949 9.62687C7.71014 10.3575 8.89475 10.3575 9.6254 9.62687C10.3561 8.89622 10.3561 7.71161 9.6254 6.98096C8.89475 6.25031 7.71014 6.25031 6.97949 6.98096ZM8.03785 8.5685C7.89172 8.42238 7.89172 8.18545 8.03785 8.03932C8.18398 7.89319 8.42091 7.89319 8.56704 8.03932C8.71317 8.18545 8.71317 8.42238 8.56704 8.5685C8.42091 8.71463 8.18398 8.71463 8.03785 8.5685Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.21484 3.4865C3.80963 3.49234 3.48269 3.81966 3.47732 4.22488L3.37507 11.9439C3.37239 12.1458 3.45142 12.3402 3.59419 12.483L12.267 21.1558C12.5593 21.4481 13.0331 21.4481 13.3254 21.1558L21.1558 13.3254C21.4481 13.0331 21.4481 12.5593 21.1558 12.267L12.483 3.59419C12.34 3.4512 12.1452 3.37216 11.943 3.37508L4.21484 3.4865ZM4.87587 11.6479L4.9643 4.9726L11.6483 4.87624L19.5683 12.7962L12.7962 19.5683L4.87587 11.6479Z" fill="currentColor"/>
  </svg>
`;

const TagIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.97949 6.98096C6.24884 7.71161 6.24884 8.89622 6.97949 9.62687C7.71014 10.3575 8.89475 10.3575 9.6254 9.62687C10.3561 8.89622 10.3561 7.71161 9.6254 6.98096C8.89475 6.25031 7.71014 6.25031 6.97949 6.98096ZM8.03785 8.5685C7.89172 8.42238 7.89172 8.18545 8.03785 8.03932C8.18398 7.89319 8.42091 7.89319 8.56704 8.03932C8.71317 8.18545 8.71317 8.42238 8.56704 8.5685C8.42091 8.71463 8.18398 8.71463 8.03785 8.5685Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.21484 3.4865C3.80963 3.49234 3.48269 3.81966 3.47732 4.22488L3.37507 11.9439C3.37239 12.1458 3.45142 12.3402 3.59419 12.483L12.267 21.1558C12.5593 21.4481 13.0331 21.4481 13.3254 21.1558L21.1558 13.3254C21.4481 13.0331 21.4481 12.5593 21.1558 12.267L12.483 3.59419C12.34 3.4512 12.1452 3.37216 11.943 3.37508L4.21484 3.4865ZM4.87587 11.6479L4.9643 4.9726L11.6483 4.87624L19.5683 12.7962L12.7962 19.5683L4.87587 11.6479Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: TagIcon,
  IconSvg: IconSvg
} as IconType;
